export function initStickyBuybox(
    target = document.querySelector('.js-stickyOrderBuybox'),
    itemCard = document.querySelector('.itemcard')
) {
    if (!target || !itemCard) return;
    function updateTargetSize() {
        const targetRect = target.getBoundingClientRect();
        target.style.height = `${targetRect.height}px`;

    }
    function toggleSticky(isSticky) {
        target.classList.toggle('is-sticky', isSticky);
        if(isSticky){
            const targetRect = target.querySelector(":scope > *").getBoundingClientRect();
            document.body.style.setProperty('--sticky-buy-box-height', targetRect.height + 'px');
        }else{
            document.body.style.setProperty('--sticky-buy-box-height', '0px');
        }
    }
    // Beobachtet itemCard separat und merkt sich Sichtbarkeit
    const itemCardObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            const boundingTop = entry.boundingClientRect.top;
            const isVisible = entry.isIntersecting;
            if (!isVisible && boundingTop < 0) {
                toggleSticky(false);
            } else {
                toggleSticky(true);
            }
        });
    }, {
        root: null,
        threshold: 0
    });


    // Beobachtet die Buybox
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            const boundingTop = entry.boundingClientRect.top;
            const isVisible = entry.isIntersecting;
            if (!isVisible && boundingTop < 0) {
                toggleSticky(true);
            } else {
                toggleSticky(false);

            }
        });
    }, {
        root: null,
        threshold: 0
    });

    setTimeout(function () {
        updateTargetSize();
        window.addEventListener('resize', updateTargetSize);
        itemCardObserver.observe(itemCard);
        observer.observe(target);
    }, 200);

}
